module Hereabout.Social.Json where

import Prelude

import Data.Argonaut (class DecodeJson, JsonDecodeError(..), decodeJson)
import Data.Argonaut.Core (jsonEmptyObject)
import Data.Argonaut.Encode (class EncodeJson, encodeJson, (:=), (~>))
import Hereabout.Types (PostComment(..))


newtype HSAPIJson a = HSAPIJson a

instance encodeJsonGeoPosition :: EncodeJson (HSAPIJson PostComment) where
  encodeJson (HSAPIJson (PostComment pc)) =
    "content" := pc.content
      ~> jsonEmptyObject

